import { Box } from '@chakra-ui/react';

export const MarkOne = ({ ...rest }) => {
  return (
    <Box {...rest}>
      <svg
        width="auto"
        height="auto"
        viewBox="0 0 500 75"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.415 60.21C25.365 61.2 23.865 61.995 21.915 62.595C19.995 63.165 18 63.45 15.93 63.45C11.7 63.45 8.205 62.085 5.445 59.355C2.715 56.595 1.35 53.055 1.35 48.735C1.35 46.305 1.86 43.905 2.88 41.535C3.9 39.165 5.49 37.2 7.65 35.64C9.81 34.08 12.57 33.3 15.93 33.3C18.39 33.3 20.49 33.645 22.23 34.335C23.97 35.025 25.35 35.835 26.37 36.765L27.135 43.11L23.04 43.515L22.32 39.465C20.52 38.295 18.36 37.71 15.84 37.71C13.08 37.71 10.86 38.67 9.18 40.59C7.53 42.51 6.705 45.135 6.705 48.465C6.705 51.945 7.59 54.585 9.36 56.385C11.13 58.155 13.455 59.04 16.335 59.04C18.735 59.04 20.7 58.62 22.23 57.78L22.95 53.415L27.045 53.82L26.415 60.21ZM51.2789 52.92C51.2789 56.07 50.2739 58.62 48.2639 60.57C46.2839 62.49 43.7039 63.45 40.5239 63.45C37.4339 63.45 34.9439 62.52 33.0539 60.66C31.1939 58.8 30.2639 56.28 30.2639 53.1C30.2639 50.16 31.1489 47.64 32.9189 45.54C34.6889 43.41 37.3139 42.345 40.7939 42.345C44.3039 42.345 46.9289 43.395 48.6689 45.495C50.4089 47.595 51.2789 50.07 51.2789 52.92ZM46.2839 52.785C46.2839 50.625 45.7589 48.975 44.7089 47.835C43.6889 46.695 42.3539 46.125 40.7039 46.125C38.9939 46.125 37.6589 46.74 36.6989 47.97C35.7389 49.17 35.2589 50.79 35.2589 52.83C35.2589 54.75 35.7089 56.37 36.6089 57.69C37.5389 59.01 38.9039 59.67 40.7039 59.67C42.4439 59.67 43.8089 59.04 44.7989 57.78C45.7889 56.49 46.2839 54.825 46.2839 52.785ZM85.9655 46.485H83.9405L78.2705 63H74.6705L69.0905 49.68H68.8655L63.6005 63H60.1805L54.3755 46.485H52.3955V42.795H62.6555V46.485H59.5055L62.6105 56.205H62.8805L68.0555 42.795H71.0255L76.8305 56.07H77.1005L79.5305 46.485H76.5155V42.795H85.9655V46.485ZM109.668 52.425C109.668 55.275 108.918 57.825 107.418 60.075C105.918 62.325 103.608 63.45 100.488 63.45C97.3078 63.45 95.0728 62.25 93.7828 59.85C93.7228 60.21 93.6478 60.735 93.5578 61.425C93.4678 62.115 93.3928 62.64 93.3328 63H88.5628C88.7428 62.01 88.9078 61.005 89.0578 59.985C89.2078 58.935 89.2828 57.915 89.2828 56.925V35.73H86.2678V32.04H94.0528V46.8C94.6528 45.6 95.4928 44.565 96.5728 43.695C97.6828 42.825 99.1678 42.39 101.028 42.39C103.578 42.39 105.648 43.275 107.238 45.045C108.858 46.785 109.668 49.245 109.668 52.425ZM104.673 52.83C104.673 50.7 104.193 49.08 103.233 47.97C102.273 46.83 101.043 46.26 99.5428 46.26C97.8328 46.26 96.4978 46.89 95.5378 48.15C94.5778 49.41 94.0828 50.775 94.0528 52.245V53.685C94.0528 55.335 94.5328 56.745 95.4928 57.915C96.4828 59.055 97.7728 59.625 99.3628 59.625C101.043 59.625 102.348 59.01 103.278 57.78C104.208 56.55 104.673 54.9 104.673 52.83ZM133.155 52.92C133.155 56.07 132.15 58.62 130.14 60.57C128.16 62.49 125.58 63.45 122.4 63.45C119.31 63.45 116.82 62.52 114.93 60.66C113.07 58.8 112.14 56.28 112.14 53.1C112.14 50.16 113.025 47.64 114.795 45.54C116.565 43.41 119.19 42.345 122.67 42.345C126.18 42.345 128.805 43.395 130.545 45.495C132.285 47.595 133.155 50.07 133.155 52.92ZM128.16 52.785C128.16 50.625 127.635 48.975 126.585 47.835C125.565 46.695 124.23 46.125 122.58 46.125C120.87 46.125 119.535 46.74 118.575 47.97C117.615 49.17 117.135 50.79 117.135 52.83C117.135 54.75 117.585 56.37 118.485 57.69C119.415 59.01 120.78 59.67 122.58 59.67C124.32 59.67 125.685 59.04 126.675 57.78C127.665 56.49 128.16 54.825 128.16 52.785ZM156.955 46.485H154.84L148.09 63L145.84 68.805H148.81V72.585H138.01V68.805H141.43L143.41 63.18L136.255 46.485H134.05V42.795H143.995V46.485H141.43L146.11 57.42H146.38L150.16 46.485H147.865V42.795H156.955V46.485ZM191.928 60.21C190.878 61.2 189.378 61.995 187.428 62.595C185.508 63.165 183.513 63.45 181.443 63.45C177.213 63.45 173.718 62.085 170.958 59.355C168.228 56.595 166.863 53.055 166.863 48.735C166.863 46.305 167.373 43.905 168.393 41.535C169.413 39.165 171.003 37.2 173.163 35.64C175.323 34.08 178.083 33.3 181.443 33.3C183.903 33.3 186.003 33.645 187.743 34.335C189.483 35.025 190.863 35.835 191.883 36.765L192.648 43.11L188.553 43.515L187.833 39.465C186.033 38.295 183.873 37.71 181.353 37.71C178.593 37.71 176.373 38.67 174.693 40.59C173.043 42.51 172.218 45.135 172.218 48.465C172.218 51.945 173.103 54.585 174.873 56.385C176.643 58.155 178.968 59.04 181.848 59.04C184.248 59.04 186.213 58.62 187.743 57.78L188.463 53.415L192.558 53.82L191.928 60.21ZM216.792 52.92C216.792 56.07 215.787 58.62 213.777 60.57C211.797 62.49 209.217 63.45 206.037 63.45C202.947 63.45 200.457 62.52 198.567 60.66C196.707 58.8 195.777 56.28 195.777 53.1C195.777 50.16 196.662 47.64 198.432 45.54C200.202 43.41 202.827 42.345 206.307 42.345C209.817 42.345 212.442 43.395 214.182 45.495C215.922 47.595 216.792 50.07 216.792 52.92ZM211.797 52.785C211.797 50.625 211.272 48.975 210.222 47.835C209.202 46.695 207.867 46.125 206.217 46.125C204.507 46.125 203.172 46.74 202.212 47.97C201.252 49.17 200.772 50.79 200.772 52.83C200.772 54.75 201.222 56.37 202.122 57.69C203.052 59.01 204.417 59.67 206.217 59.67C207.957 59.67 209.322 59.04 210.312 57.78C211.302 56.49 211.797 54.825 211.797 52.785ZM243.277 63H235.312V59.625C233.992 62.145 231.772 63.405 228.652 63.405C226.732 63.405 225.067 62.835 223.657 61.695C222.277 60.525 221.587 58.68 221.587 56.16V46.485H218.572V42.795H226.402V54.405C226.402 56.325 226.747 57.69 227.437 58.5C228.127 59.28 229.102 59.67 230.362 59.67C231.862 59.67 233.047 59.145 233.917 58.095C234.817 57.045 235.282 55.8 235.312 54.36V46.485H231.712V42.795H240.127V59.31H243.277V63ZM269.924 63H259.124V59.31H262.094V51.39C262.094 49.47 261.749 48.12 261.059 47.34C260.369 46.53 259.409 46.125 258.179 46.125C256.649 46.125 255.434 46.62 254.534 47.61C253.664 48.6 253.214 49.815 253.184 51.255V59.31H256.199V63H245.354V59.31H248.369V46.53H245.219V42.795H253.184V46.08C254.594 43.62 256.829 42.39 259.889 42.39C261.809 42.39 263.459 42.975 264.839 44.145C266.219 45.315 266.909 47.145 266.909 49.635V59.31H269.924V63ZM288.102 57.06C287.532 61.32 285.162 63.45 280.992 63.45C278.832 63.45 277.107 62.88 275.817 61.74C274.557 60.6 273.927 59.01 273.927 56.97V46.35H270.957V42.795H273.927V36.54H278.742V42.795H286.257V46.35H278.742V56.205C278.742 58.335 279.672 59.4 281.532 59.4C282.042 59.4 282.612 59.22 283.242 58.86C283.872 58.47 284.307 57.495 284.547 55.935L288.102 57.06ZM301.678 42.48C303.028 42.48 304.288 42.855 305.458 43.605L306.313 49.905L302.578 50.355L301.813 46.89C301.213 46.59 300.703 46.44 300.283 46.44C299.443 46.44 298.708 46.785 298.078 47.475C297.478 48.165 297.178 49.125 297.178 50.355V59.31H301.183V63H289.348V59.31H292.363V46.53H289.213V42.795H296.818V46.575C297.178 45.435 297.748 44.475 298.528 43.695C299.338 42.885 300.388 42.48 301.678 42.48ZM330.776 46.485H328.661L321.911 63L319.661 68.805H322.631V72.585H311.831V68.805H315.251L317.231 63.18L310.076 46.485H307.871V42.795H317.816V46.485H315.251L319.931 57.42H320.201L323.981 46.485H321.686V42.795H330.776V46.485ZM367.143 43.29L362.823 43.65L361.923 38.025H356.208V58.725H361.113V63H346.488V58.725H351.213V38.025H345.453L344.553 43.65L340.278 43.29L341.178 33.75H366.243L367.143 43.29ZM372.394 38.61V33.3H377.299V38.61H372.394ZM380.449 63H369.649V59.31H372.664V46.53H369.469V42.795H377.434V59.31H380.449V63ZM398.988 57.06C398.418 61.32 396.048 63.45 391.878 63.45C389.718 63.45 387.993 62.88 386.703 61.74C385.443 60.6 384.813 59.01 384.813 56.97V46.35H381.843V42.795H384.813V36.54H389.628V42.795H397.143V46.35H389.628V56.205C389.628 58.335 390.558 59.4 392.418 59.4C392.928 59.4 393.498 59.22 394.128 58.86C394.758 58.47 395.193 57.495 395.433 55.935L398.988 57.06ZM410.585 63H399.785V59.31H402.8V35.73H399.605V32.04H407.57V59.31H410.585V63ZM431.884 56.835C431.704 58.605 430.834 60.15 429.274 61.47C427.714 62.79 425.569 63.45 422.839 63.45C419.899 63.45 417.484 62.595 415.594 60.885C413.704 59.145 412.759 56.595 412.759 53.235C412.759 50.145 413.614 47.565 415.324 45.495C417.064 43.425 419.479 42.39 422.569 42.39C425.359 42.39 427.564 43.23 429.184 44.91C430.834 46.56 431.674 48.66 431.704 51.21C431.704 52.05 431.614 52.95 431.434 53.91H417.799C418.069 57.69 419.869 59.58 423.199 59.58C424.759 59.58 425.869 59.205 426.529 58.455C427.219 57.705 427.669 56.91 427.879 56.07L431.884 56.835ZM426.754 50.94C426.874 49.74 426.589 48.615 425.899 47.565C425.239 46.485 424.114 45.945 422.524 45.945C421.084 45.945 419.989 46.425 419.239 47.385C418.489 48.345 418.024 49.53 417.844 50.94H426.754Z"
          fill="#342F2F"
        />
        <path
          d="M475.397 62.6781L462.975 54.9141L471.746 48.3595L475.855 62.3303C475.935 62.6018 475.637 62.8281 475.397 62.6781ZM470.991 48.1558L462.738 54.3227V48.1558H470.991ZM470.906 47.5404H462.738V42.0594L470.906 47.5404ZM471.381 47.1183L462.983 41.4824L468.612 37.7044L471.381 47.1183ZM462.123 48.1558V54.3227L453.87 48.1558H462.123ZM453.114 48.3595L461.886 54.9141L449.464 62.6781C449.224 62.8281 448.926 62.6018 449.005 62.3303L453.114 48.3595ZM462.123 47.5404H453.955L462.123 42.0594V47.5404ZM468.285 37.1828L462.738 40.9053V32.3217L468.285 37.1828ZM468.195 36.2854L462.897 31.643L466.024 28.9032L468.195 36.2854ZM465.833 28.2526L462.738 30.9642V17.7316L465.833 28.2526ZM453.48 47.1183L456.248 37.7044L461.878 41.4824L453.48 47.1183ZM456.575 37.1828L462.123 32.3217V40.9053L456.575 37.1828ZM461.964 31.643L456.666 36.2854L458.837 28.9032L461.964 31.643ZM462.123 30.9642L459.028 28.2526L462.123 17.7316V30.9642Z"
          stroke="#342F2F"
          strokeWidth="0.615385"
        />
        <path
          d="M459.924 36.1519H464.228L463.424 21.519H460.727L459.924 36.1519Z"
          fill="#342F2F"
        />
        <rect
          width="0.860759"
          height="7.74684"
          transform="matrix(1 0 0 -1 461.674 24.6177)"
          fill="#342F2F"
        />
        <path
          d="M464.228 0H459.924L460.727 14.6329H463.424L464.228 0Z"
          fill="#342F2F"
        />
        <rect
          width="0.860759"
          height="7.74684"
          transform="matrix(-1 0 0 1 462.506 11.1899)"
          fill="#342F2F"
        />
        <path
          d="M444 20.2278V15.924L458.633 16.7274V19.4245L444 20.2278Z"
          fill="#342F2F"
        />
        <rect
          x="455.534"
          y="18.4776"
          width="0.860759"
          height="7.74684"
          transform="rotate(-90 455.534 18.4776)"
          fill="#342F2F"
        />
        <path
          d="M480.152 15.9241V20.2279L465.519 19.4245V16.7274L480.152 15.9241Z"
          fill="#342F2F"
        />
        <rect
          x="468.962"
          y="17.6456"
          width="0.860759"
          height="7.74684"
          transform="rotate(90 468.962 17.6456)"
          fill="#342F2F"
        />
        <path
          d="M476.654 28.9775L478.806 25.2503L465.732 18.6296L464.383 20.9653L476.654 28.9775Z"
          fill="#342F2F"
        />
        <rect
          width="0.860759"
          height="7.74684"
          transform="matrix(0.5 -0.866025 -0.866025 -0.5 467.54 21.6947)"
          fill="#342F2F"
        />
        <path
          d="M447.498 7.17441L445.346 10.9016L458.42 17.5223L459.768 15.1866L447.498 7.17441Z"
          fill="#342F2F"
        />
        <rect
          width="0.860759"
          height="7.74684"
          transform="matrix(-0.5 0.866025 0.866025 0.5 456.328 14.2602)"
          fill="#342F2F"
        />
        <path
          d="M447.498 28.9775L445.346 25.2503L458.42 18.6296L459.768 20.9653L447.498 28.9775Z"
          fill="#342F2F"
        />
        <rect
          x="456.611"
          y="21.6947"
          width="0.860759"
          height="7.74684"
          transform="rotate(-120 456.611 21.6947)"
          fill="#342F2F"
        />
        <path
          d="M476.654 7.17441L478.806 10.9016L465.732 17.5223L464.383 15.1866L476.654 7.17441Z"
          fill="#342F2F"
        />
        <rect
          x="467.824"
          y="14.2602"
          width="0.860759"
          height="7.74684"
          transform="rotate(60 467.824 14.2602)"
          fill="#342F2F"
        />
        <path
          d="M469.25 34.8062L472.977 32.6543L464.965 20.3835L462.63 21.732L469.25 34.8062Z"
          fill="#342F2F"
        />
        <rect
          width="0.860759"
          height="7.74684"
          transform="matrix(0.866025 -0.5 -0.5 -0.866025 464.999 23.9421)"
          fill="#342F2F"
        />
        <path
          d="M454.901 1.34579L451.174 3.49769L459.186 15.7685L461.522 14.42L454.901 1.34579Z"
          fill="#342F2F"
        />
        <rect
          width="0.860759"
          height="7.74684"
          transform="matrix(-0.866025 0.5 0.5 0.866025 459.006 11.8972)"
          fill="#342F2F"
        />
        <path
          d="M454.902 34.8062L451.174 32.6543L459.187 20.3835L461.522 21.732L454.902 34.8062Z"
          fill="#342F2F"
        />
        <rect
          x="459.153"
          y="23.9421"
          width="0.860759"
          height="7.74684"
          transform="rotate(-150 459.153 23.9421)"
          fill="#342F2F"
        />
        <path
          d="M469.25 1.34579L472.978 3.49769L464.965 15.7685L462.63 14.42L469.25 1.34579Z"
          fill="#342F2F"
        />
        <rect
          x="465.146"
          y="11.8972"
          width="0.860759"
          height="7.74684"
          transform="rotate(30 465.146 11.8972)"
          fill="#342F2F"
        />
        <rect
          x="461.722"
          y="17.7215"
          width="25.519"
          height="0.708861"
          fill="#342F2F"
        />
        <path
          d="M485.823 14.1772L500 12.7595L497.519 17.0127L500 21.6203L485.823 20.557V14.1772Z"
          fill="#342F2F"
        />
      </svg>

    </Box>
  );
};

export const MarkTwo = ({ ...rest }) => {
  return (
    <Box {...rest}>
      <svg
        width="auto"
        height="auto"
        viewBox="0 0 217 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0)">
          <path
            d="M47.547 56.978C45.657 58.76 42.957 60.191 39.447 61.271C35.991 62.297 32.4 62.81 28.674 62.81C21.06 62.81 14.769 60.353 9.801 55.439C4.887 50.471 2.43 44.099 2.43 36.323C2.43 31.949 3.348 27.629 5.184 23.363C7.02 19.097 9.882 15.56 13.77 12.752C17.658 9.944 22.626 8.54 28.674 8.54C33.102 8.54 36.882 9.161 40.014 10.403C43.146 11.645 45.63 13.103 47.466 14.777L48.843 26.198L41.472 26.927L40.176 19.637C36.936 17.531 33.048 16.478 28.512 16.478C23.544 16.478 19.548 18.206 16.524 21.662C13.554 25.118 12.069 29.843 12.069 35.837C12.069 42.101 13.662 46.853 16.848 50.093C20.034 53.279 24.219 54.872 29.403 54.872C33.723 54.872 37.26 54.116 40.014 52.604L41.31 44.747L48.681 45.476L47.547 56.978ZM99.916 56.978C98.026 58.76 95.326 60.191 91.816 61.271C88.36 62.297 84.769 62.81 81.043 62.81C73.429 62.81 67.138 60.353 62.17 55.439C57.256 50.471 54.799 44.099 54.799 36.323C54.799 31.949 55.717 27.629 57.553 23.363C59.389 19.097 62.251 15.56 66.139 12.752C70.027 9.944 74.995 8.54 81.043 8.54C85.471 8.54 89.251 9.161 92.383 10.403C95.515 11.645 97.999 13.103 99.835 14.777L101.212 26.198L93.841 26.927L92.545 19.637C89.305 17.531 85.417 16.478 80.881 16.478C75.913 16.478 71.917 18.206 68.893 21.662C65.923 25.118 64.438 29.843 64.438 35.837C64.438 42.101 66.031 46.853 69.217 50.093C72.403 53.279 76.588 54.872 81.772 54.872C86.092 54.872 89.629 54.116 92.383 52.604L93.679 44.747L101.05 45.476L99.916 56.978ZM154.796 26.522L147.02 27.17L145.4 17.045H135.113V54.305H143.942V62H117.617V54.305H126.122V17.045H115.754L114.134 27.17L106.439 26.522L108.059 9.35H153.176L154.796 26.522Z"
            fill="#342F2F"
          />
          <path
            d="M195.977 61.0318L185.87 54.7151L193.077 49.3298L196.42 60.6957C196.497 60.9581 196.209 61.1768 195.977 61.0318ZM192.347 49.1329L185.641 54.1434V49.1329H192.347ZM192.265 48.538H185.641V44.0935L192.265 48.538ZM192.724 48.13L185.878 43.5357L190.467 40.456L192.724 48.13ZM185.047 49.1329V54.1434L178.341 49.1329H185.047ZM177.611 49.3298L184.818 54.7151L174.711 61.0318C174.479 61.1768 174.191 60.9581 174.268 60.6957L177.611 49.3298ZM185.047 48.538H178.423L185.047 44.0935V48.538ZM190.151 39.9518L185.641 42.9779V36.0001L190.151 39.9518ZM190.064 39.0843L185.795 35.344L188.314 33.1366L190.064 39.0843ZM188.129 32.5078L185.641 34.6879V24.0488L188.129 32.5078ZM177.964 48.13L180.221 40.456L184.81 43.5357L177.964 48.13ZM180.537 39.9518L185.047 36.0001V42.9779L180.537 39.9518ZM184.893 35.344L180.624 39.0843L182.374 33.1366L184.893 35.344ZM185.047 34.6879L182.559 32.5078L185.047 24.0488V34.6879Z"
            stroke="#342F2F"
            strokeWidth="0.594872"
          />
          <path
            d="M183.258 39.0979H186.841L186.172 26.9154H183.926L183.258 39.0979Z"
            fill="#342F2F"
          />
          <rect
            width="0.716617"
            height="6.44955"
            transform="matrix(1 0 0 -1 184.714 29.4952)"
            fill="#342F2F"
          />
          <path
            d="M186.84 9H183.257L183.926 21.1825H186.172L186.84 9Z"
            fill="#342F2F"
          />
          <rect
            width="0.716617"
            height="6.44955"
            transform="matrix(-1 0 0 1 185.407 18.316)"
            fill="#342F2F"
          />
          <path
            d="M170 25.8405V22.2574L182.182 22.9262V25.1716L170 25.8405Z"
            fill="#342F2F"
          />
          <rect
            x="179.603"
            y="24.3834"
            width="0.716617"
            height="6.44955"
            transform="rotate(-90 179.603 24.3834)"
            fill="#342F2F"
          />
          <path
            d="M200.098 22.2574V25.8405L187.915 25.1717V22.9263L200.098 22.2574Z"
            fill="#342F2F"
          />
          <rect
            x="190.782"
            y="23.6906"
            width="0.716617"
            height="6.44955"
            transform="rotate(90 190.782 23.6906)"
            fill="#342F2F"
          />
          <path
            d="M197.186 33.125L198.978 30.0219L188.093 24.5099L186.97 26.4545L197.186 33.125Z"
            fill="#342F2F"
          />
          <rect
            width="0.716617"
            height="6.44955"
            transform="matrix(0.5 -0.866025 -0.866025 -0.5 189.598 27.0617)"
            fill="#342F2F"
          />
          <path
            d="M172.912 14.973L171.12 18.076L182.005 23.588L183.128 21.6434L172.912 14.973Z"
            fill="#342F2F"
          />
          <rect
            width="0.716617"
            height="6.44955"
            transform="matrix(-0.5 0.866025 0.866025 0.5 180.263 20.8722)"
            fill="#342F2F"
          />
          <path
            d="M172.912 33.125L171.12 30.0219L182.005 24.5099L183.128 26.4545L172.912 33.125Z"
            fill="#342F2F"
          />
          <rect
            x="180.5"
            y="27.0617"
            width="0.716617"
            height="6.44955"
            transform="rotate(-120 180.5 27.0617)"
            fill="#342F2F"
          />
          <path
            d="M197.186 14.973L198.978 18.076L188.093 23.588L186.97 21.6434L197.186 14.973Z"
            fill="#342F2F"
          />
          <rect
            x="189.835"
            y="20.8722"
            width="0.716617"
            height="6.44955"
            transform="rotate(60 189.835 20.8722)"
            fill="#342F2F"
          />
          <path
            d="M191.022 37.9775L194.125 36.186L187.454 25.9701L185.51 27.0927L191.022 37.9775Z"
            fill="#342F2F"
          />
          <rect
            width="0.716617"
            height="6.44955"
            transform="matrix(0.866025 -0.5 -0.5 -0.866025 187.482 28.9328)"
            fill="#342F2F"
          />
          <path
            d="M179.076 10.1204L175.973 11.912L182.643 22.1279L184.588 21.0052L179.076 10.1204Z"
            fill="#342F2F"
          />
          <rect
            width="0.716617"
            height="6.44955"
            transform="matrix(-0.866025 0.5 0.5 0.866025 182.493 18.9049)"
            fill="#342F2F"
          />
          <path
            d="M179.076 37.9775L175.973 36.186L182.643 25.9701L184.588 27.0927L179.076 37.9775Z"
            fill="#342F2F"
          />
          <rect
            x="182.615"
            y="28.9328"
            width="0.716617"
            height="6.44955"
            transform="rotate(-150 182.615 28.9328)"
            fill="#342F2F"
          />
          <path
            d="M191.022 10.1204L194.125 11.912L187.455 22.1279L185.51 21.0052L191.022 10.1204Z"
            fill="#342F2F"
          />
          <rect
            x="187.605"
            y="18.9049"
            width="0.716617"
            height="6.44955"
            transform="rotate(30 187.605 18.9049)"
            fill="#342F2F"
          />
          <rect
            x="184.754"
            y="23.7539"
            width="21.2456"
            height="0.590155"
            fill="#342F2F"
          />
          <path
            d="M204.819 20.8031L216.622 19.6228L214.557 23.1637L216.622 26.9997L204.819 26.1145V20.8031Z"
            fill="#342F2F"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect
              width="217"
              height="70"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>

    </Box>
  );
};
